import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  yes: {
    color: theme.palette.success.main,
  },
  deficiency: {
    color: theme.palette.warning.main,
  },
  no: {
    color: theme.palette.error.main,
  },
}));
